import { Text } from '@interco/inter-ui/components/Text'
import { interWbNavigate } from '@interco/inter-webview-bridge'
import ArrowLeft from '@interco/icons/core/action-navigation/ic_arrow_left'

import * as S from './styles'

type TProps = {
  title: string
}
const Header = ({ title }: TProps) => {
  const goBack = () => {
    // tagEvent
    interWbNavigate.requestGoBack()
  }

  return (
    <S.Header>
      <ArrowLeft onClick={goBack} width={24} height={24} color="var(--primary500)" />
      <Text variant="headline-h3" semiBold>
        {title}
      </Text>
      <div />
    </S.Header>
  )
}

export default Header
